var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg006Linkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2239_88078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6092 0C7.81723 0 0.6875 7.16479 0.6875 16C0.6875 24.8352 7.81723 32 16.6092 32C25.4012 32 32.5309 24.8352 32.5309 16C32.5309 7.16479 25.4012 0 16.6092 0ZM11.9825 24.1875H8.10488V12.4641H11.9825V24.1875ZM10.0438 10.8633H10.0186C8.71735 10.8633 7.87578 9.96313 7.87578 8.83813C7.87578 7.68774 8.7431 6.8125 10.0696 6.8125C11.3961 6.8125 12.2124 7.68774 12.2376 8.83813C12.2376 9.96313 11.3961 10.8633 10.0438 10.8633ZM25.9646 24.1875H22.0874V17.9158C22.0874 16.3396 21.5259 15.2646 20.1229 15.2646C19.0518 15.2646 18.4138 15.9897 18.1334 16.6897C18.0309 16.9402 18.0059 17.2903 18.0059 17.6406V24.1875H14.1285C14.1285 24.1875 14.1793 13.564 14.1285 12.4641H18.0059V14.124C18.5212 13.3252 19.4432 12.189 21.5004 12.189C24.0516 12.189 25.9646 13.8645 25.9646 17.4653V24.1875Z",
    fill: "#2E1A47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_88078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8434,
    height: 32,
    fill: "white",
    transform: "translate(0.6875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg006Linkedin);
export default __webpack_public_path__ + "static/media/006-linkedin.942ef81e992e6c22f968fa2b5f12a64d.svg";
export { ForwardRef as ReactComponent };